import React, { memo, useMemo, useState } from 'react';
import moment from 'moment';
import { OverlayTrigger, Popover, Table, Form } from '../ui-kit';
import { IconExclamationTriangle, IconSpinner } from '../ui-kit/icons';
import Loader from '../general/Loader';
import { formatTime } from '../../utils/time';

const TeamMembershipAuditTable = ({ activePeriods }) => (
  <Table bordered condensed className="p-0 m-0">
    <thead>
      <tr>
        <th>{I18n.t('attributes.start_time')}</th>
        <th>{I18n.t('attributes.end_time')}</th>
      </tr>
    </thead>
    <tbody>
      {activePeriods.length === 0 && (
        <tr>
          <td colSpan="3" className="text-center">
            <i>{I18n.t('no_results_found')}</i>
          </td>
        </tr>
      )}
      {activePeriods.map(period => (
        <tr key={period.id}>
          <td>{formatTime(period.start_time)}</td>
          <td>{formatTime(period.end_time) || <i>{I18n.t('not_applicable_abbr')}</i>}</td>
        </tr>
      ))}
    </tbody>
  </Table>
);

const TeamMembershipTableCell = ({ activePeriods, readonly, onToggle /*, onContextMenu */ }) => {
  const [loading, setLoading] = useState(false);
  const now = moment();

  const checked = activePeriods.some(period =>
    period.end_time ? now.isBetween(period.start_time, period.end_time) : now.isAfter(period.start_time)
  );

  // Returns true iff there are any changes to team memberships scheduled for
  // the future. This means that the team membership will start or end in the
  // future
  const teamHasScheduledExchange = activePeriods.some(
    c => now.isBefore(c.start_time) || (c.end_time && now.isBefore(c.end_time))
  );

  const popover = useMemo(
    () => (
      <Popover id="team-membership-history" style={{ width: '40rem' }}>
        <Popover.Header>{I18n.t('audit_log.title')}</Popover.Header>
        <Popover.Body className="p-0">
          {!activePeriods && <Loader />}
          {activePeriods && <TeamMembershipAuditTable activePeriods={activePeriods} />}
        </Popover.Body>
      </Popover>
    ),
    [activePeriods]
  );

  const toggleChecked = async () => {
    if (readonly || loading) return;
    setLoading(true);
    try {
      await onToggle(!checked);
    } finally {
      setLoading(false);
    }
  };

  // const openActionMenu = event => {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   if (readonly) return;
  //   onContextMenu(event);
  // };

  return (
    <div className="text-center" onClick={toggleChecked} /*onContextMenu={openActionMenu} */>
      {loading && <IconSpinner spin />}
      {!loading && (
        <OverlayTrigger overlay={popover}>
          <span>
            {readonly && checked ? (
              <Form.Check checked={true} readOnly={true} className="pe-none" />
            ) : (
              <Form.Check checked={checked} readOnly={true} className="pe-none" />
            )}{' '}
            {teamHasScheduledExchange && (
              <IconExclamationTriangle
                title={I18n.t('group_membership_exchange.scheduled_warning_title')}
                aria-label={I18n.t('group_membership_exchange.scheduled_warning_title')}
              />
            )}
            {/*
            <button
              type="button"
              className="btn btn-link btn-sm p-0 ms-1 align-baseline sr-only"
              onClick={openActionMenu}
              aria-label={I18n.t('skills.audit')}
            >
              <span aria-hidden="true">⋮</span>
            </button>
            */}
          </span>
        </OverlayTrigger>
      )}
    </div>
  );
};

export default memo(TeamMembershipTableCell);
